import Cookies from 'js-cookie';
import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { services } from "../helpers/service";
import { utils } from "../helpers/utils";
import { dialog } from "../components/dialog";
import { termOfUse } from "../components/terms-of-use";

class Crossknowledge {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.COOKIES = 'CROSSKNOWLEDGE';
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    // document.addEventListener('submit', this.inscriptionCrossknowledge);

    
    this.reloadAfterIndetify();
    this.crossknowledgeFormTitleHandler();

    document.addEventListener('TERMS_OF_USE_SERVICE', this.crossknowledgeFormHandler);
    document.addEventListener('FORM_CK_VALIDATION', this.inscriptionCrossknowledge);

    if(debug.DEBUG) console.log('async/crossknowledge.js');
  }

  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger="crossknowledge"]') || event.target.getAttribute('href') === '#innovalenligne') {
      // open dialog
      event.preventDefault();
      event.stopPropagation();
      
      Cookies.set(this.COOKIES, 'auto');
      if (!utils.isUserLogged()) {
        dialog.open('popin-crossknowledge');
      } else {
        this.checkCrossknowledge(null);
      }
    } 
  }

  crossknowledgeFormHandler = () => {
    const form = document.querySelector('[data-js-crossknowledge-form]');
    if (form && !utils.isUserLogged() && !termOfUse.getService()) {
      setTimeout(() => {
        dialog.lock('popin-crossknowledge');
        dialog.open('popin-crossknowledge');
      }, 1000);
    }
  }

  checkCrossknowledge = (type) => {
    dialog.open('popin-loading');
    const formation = document.querySelector('[data-js-crossknowledge-formation]')?.getAttribute('data-js-crossknowledge-formation') ?? null;
    services.use('crossknowledge', { formation: formation, connected : type })
      .then((response) => {
        response = JSON.parse(response);
        if (response === undefined) return;
        
        if (response.action === 'displayPopin') {
          dialog.get('popin-crossknowledge', '[data-js-dialog-title]').textContent = response.message;
          dialog.get('popin-crossknowledge', '.c-button--theme').classList.add('u-hidden');
          dialog.open('popin-crossknowledge');
        } else if (response.action === 'redirect') {
          Cookies.remove(this.COOKIES);
          window.location.href = response.url;
        }
        if (type === 'auto') {
          Cookies.remove(this.COOKIES);
        }
    });
  }
  /**
   * Handles the title for the Crossknowledge form.
   * 
   * This function is responsible for managing the title of the form element
   * identified by the data attribute `[data-js-crossknowledge-form]`.
   */
  crossknowledgeFormTitleHandler = () => {
    const form = document.querySelector('[data-js-crossknowledge-form]');
    if (form) {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has('a') && searchParams.get("a") === 'u') {
        const title = document.querySelector('.c-banner__title');
        title.textContent = "Veuillez compléter les informations manquantes pour finaliser votre accès à Innoval en Ligne.";
      }
    }
  }

  reloadAfterIndetify = () => {
    if (Cookies.get(this.COOKIES) && termOfUse.getToken() === null) {
      this.checkCrossknowledge('auto');
    }
  }

  inscriptionCrossknowledge = (event) => {
    const data = utils.serialize(event.detail.form);
    services.use('crossknowledgeForm', data)
      .then((response) => {

        if (response === undefined) return;
        if (response.action === 'popinDisplay') {
          dialog.get('popin-crossknowledge', '[data-js-dialog-title]').textContent = response.message;
          dialog.get('popin-crossknowledge', '.c-button--theme').classList.add('u-hidden');
          dialog.open('popin-crossknowledge');
        } else if (response.action === 'redirect') {
          window.location.href = response.url;
        } else {
          dialog.close();
        }
      });
    // console.log('inscriptionCrossknowledge', event.detail.error);
  }

}
export default new Crossknowledge('[data-js-component="crossknowledge"]'); 